import { Profile } from './type';

export const profile: Profile = {
  firstName: 'John',
  lastName: 'Doe',
  email: 'john.doe@gmail.com',
  uuid: 'myuid'
};
